(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[453],{

/***/ "teGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Date", function() { return Date; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Date = function Date(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6296 24.991H7.37162C6.21062 24.991 5.26562 24.049 5.26562 22.89V13.726H24.7356V22.89C24.7356 24.049 23.7906 24.991 22.6296 24.991M7.37162 6.97302H8.44362V7.67602C8.44362 8.28602 8.93962 8.78102 9.55162 8.78102C10.1636 8.78102 10.6596 8.28602 10.6596 7.67602V6.97302H19.3416V7.67602C19.3416 8.28602 19.8376 8.78102 20.4496 8.78102C21.0616 8.78102 21.5586 8.28602 21.5586 7.67602V6.97302H22.6296C23.7906 6.97302 24.7356 7.91502 24.7356 9.07302V11.717H5.26562V9.07302C5.26562 7.91502 6.21062 6.97302 7.37162 6.97302M22.629 4.964H21.558V4.105C21.558 3.495 21.061 3 20.449 3C19.837 3 19.341 3.495 19.341 4.105V4.964H10.659V4.105C10.659 3.495 10.163 3 9.551 3C8.939 3 8.443 3.495 8.443 4.105V4.964H7.371C5.099 4.964 3.25 6.807 3.25 9.073V22.89C3.25 25.156 5.099 27 7.371 27H22.629C24.902 27 26.75 25.156 26.75 22.89V9.073C26.75 6.807 24.902 4.964 22.629 4.964"
  }));
};

/***/ })

}]);